import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography, Grid, TextField, Paper, Chip, Card, CardContent, Divider, Alert, List, ListItem, ListItemIcon, ListItemText, Avatar} from '@mui/material';
import { People, Engineering, Schedule, NotificationsActive, Sms, WhatsApp, Email, Title, Description, CheckCircle } from '@mui/icons-material';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { NotificationServices } from './NotificationServices';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { set } from 'zod';
import StatusChip from './StatusChip';
import MessageList from './MessageList';
import AllAppliedFIlters from './AllAppliedFIlters';

const ViewNotification = ({ onSubmit }) => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'notifications'
        });
    }, []);
    const [ notificationData, setNotificationData ] = useState();
    const [selectedAudience, setSelectedAudience] = useState([]);

    const getDeliveryModeIcon = (mode) => {
        switch (mode) {
            case 'push': return <NotificationsActive sx={{ fontSize: 16 }} />;
            case 'sms': return <Sms sx={{ fontSize: 16 }} />;
            case 'whatsapp': return <WhatsApp sx={{ fontSize: 16 }} />;
            case 'email': return <Email sx={{ fontSize: 16 }} />;
            default: return <NotificationsActive sx={{ fontSize: 16 }} />;
        }
    };

    const getDeliveryModeLabel = (mode) => {
        switch (mode) {
            case 'push': return 'Push Notification';
            case 'sms': return 'SMS';
            case 'whatsapp': return 'WhatsApp';
            case 'email': return 'Email';
            default: return 'Unknown';
        }
    };

    const [isLoading,setIsLoading] = useState(false);
    const {id} = useParams();
    const fetchCampaignDetails = async ()=>{
        setIsLoading(true);
        try {
            const response = await NotificationServices.fetchCampaignData(id);
            if (response.success === 1) {
                setNotificationData(response.data);
                setSelectedAudience(response.data.audienceType === 'customer' 
                    ? response.data.customerIds 
                    : response.data.expertIds); 
            } else {
                // Handle error
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.message || 'Failed to fetch campaign details.'
                })
            }
        } catch (error) {
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred.'
            })
        } finally {
            setIsLoading(false);
        }
    }
    useEffect(()=>{
        if(id){
            fetchCampaignDetails();
        }
    },[id]);
    return (
        <Box>
            <PageHeaderLayout headerTitle={`Notification Detail's`}>
                {/* <Button sx={{textTransform:'none'}} size='small' variant='contained' startIcon={<ArrowBack/>}>
                    Back
                </Button> */}
            </PageHeaderLayout>

            <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                    <Grid container spacing={1}>
                        {/* Notification Title And Message */}
                        <Grid item xs={12}>
                            <Alert severity="info" sx={{ fontSize: '0.8rem' }}>
                                <Typography sx={{ fontWeight: 600,fontSize:'.85rem'}}>
                                    Current Status:  
                                    <StatusChip notificationData={notificationData} />
                                </Typography>
                                {notificationData?.scheduleType === 'later' ? (
                                    <>
                                        {notificationData?.status === 'PENDING' && 
                                            <Typography sx={{fontSize:'0.75rem'}}>
                                                The notification will be delivered on{' '}
                                                <strong>{dayjs(notificationData?.scheduledDateTime).format('MMMM DD, YYYY at hh:mm A')}</strong>.
                                            </Typography>
                                        }
                                        {notificationData?.status === 'QUEUED' && 
                                            <Typography sx={{fontSize:'0.75rem'}}>
                                                The notification is currently queued and will be delivered on{' '}
                                                <strong>{dayjs(notificationData?.scheduledDateTime).format('MMMM DD, YYYY at hh:mm A')}</strong>.
                                            </Typography>
                                        }
                                        {notificationData?.status === 'PROCESSED' && 
                                            <Typography sx={{fontSize:'0.75rem'}}>
                                                The notification has been processed as scheduled on{' '}
                                                <strong>{dayjs(notificationData?.scheduledDateTime).format('MMMM DD, YYYY at hh:mm A')}</strong>.
                                            </Typography>
                                        }
                                        {notificationData?.status === 'COMPLETED' && 
                                            (
                                                <>
                                                    <Typography sx={{fontSize:'0.75rem'}}>
                                                        The notification compaign has been completed.
                                                    </Typography>
                                                    <Box sx={{display:'flex', alignItems:'center', gap:1}}>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#d56016',width:'25%'}}>Total Queued</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#d56016',width:'2%'}}>:</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#d56016'}}>{notificationData?.totalQueued}</Typography>
                                                    </Box>
                                                    <Box sx={{display:'flex', alignItems:'center', gap:1}}>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#348508',width:'25%'}}>Total Sent</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#348508',width:'2%'}}>:</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#348508'}}>{notificationData?.totalSent}</Typography>
                                                    </Box>
                                                    <Box sx={{display:'flex', alignItems:'center', gap:1}}>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#cc160b',width:'25%'}}>Total Failed</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#cc160b',width:'2%'}}>:</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#cc160b'}}>{notificationData?.totalFailed}</Typography>
                                                    </Box>
                                                </>
                                            )
                                        }
                                        {notificationData?.status === 'CANCELLED' && 
                                            <Typography sx={{fontSize:'0.75rem'}}>
                                                The notification has been cancelled and will not be delivered.
                                            </Typography>
                                        }
                                    </>
                                ):
                                (
                                    <>
                                        {notificationData?.status === 'QUEUED' && 
                                            <Typography sx={{fontSize:'0.75rem'}}>
                                                The notification is currently queued and will be delivered now.
                                            </Typography>
                                        }
                                        {notificationData?.status === 'PROCESSED' && 
                                            <Typography sx={{fontSize:'0.75rem'}}>
                                                The notification has been processed to deliver.
                                            </Typography>
                                        }
                                        {notificationData?.status === 'COMPLETED' && 
                                            (
                                                <>
                                                    <Typography sx={{fontSize:'0.75rem'}}>
                                                        The notification has been completed and delivered.
                                                    </Typography>
                                                    <Box sx={{display:'flex', alignItems:'center', gap:1}}>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#d56016',width:'25%'}}>Total Queued</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#d56016',width:'2%'}}>:</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#d56016'}}>{notificationData?.totalQueued}</Typography>
                                                    </Box>
                                                    <Box sx={{display:'flex', alignItems:'center', gap:1}}>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#348508',width:'25%'}}>Total Sent</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#348508',width:'2%'}}>:</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#348508'}}>{notificationData?.totalSent}</Typography>
                                                    </Box>
                                                    <Box sx={{display:'flex', alignItems:'center', gap:1}}>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#cc160b',width:'25%'}}>Total Failed</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#cc160b',width:'2%'}}>:</Typography>
                                                        <Typography sx={{fontWeight:'500',fontSize:'0.65rem',color:'#cc160b'}}>{notificationData?.totalFailed}</Typography>
                                                    </Box>
                                                </>
                                            )
                                        }
                                        {notificationData?.status === 'CANCELLED' && 
                                            <Typography sx={{fontSize:'0.75rem'}}>
                                                The notification has been cancelled and will not be delivered.
                                            </Typography>
                                        }
                                    </>
                                )}
                            </Alert>
                        </Grid>
                        {/* Summary Panel */}
                        <Grid item xs={12}>
                            <Card variant="outlined" >
                                <CardContent sx={{pb:'0px !important'}}>
                                    <Typography gutterBottom sx={{ 
                                        fontWeight: 600, 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: 1,
                                        fontSize:'.85rem',
                                        // mb: 2
                                    }}>
                                        <CheckCircle color="primary" sx={{ fontSize: '1rem' }} />
                                        Configuration Summary
                                    </Typography>

                                    <List dense sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        paddingTop: 0,
                                        gap: 2, // spacing between items
                                    }}>
                                        {/* Audience Summary */}
                                        <ListItem sx={{ px: 0 }}>
                                            {/* <ListItemIcon sx={{ minWidth: 36 }}>
                                                {notificationData?.audienceType === 'customer' ? 
                                                    <People color="primary" fontSize="small" /> : 
                                                    <Engineering color="primary" fontSize="small" />
                                                }
                                            </ListItemIcon> */}
                                            <ListItemText
                                                primary={
                                                    <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600 }}>
                                                        Target Audience
                                                    </Typography>
                                                }
                                                secondary={
                                                    <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                                        {selectedAudience?.length} {notificationData?.audienceType} 
                                                        {selectedAudience?.length > 1 && ('s')}
                                                    </Typography>
                                                }
                                            />
                                        </ListItem>

                                        {/* Schedule Summary */}
                                        <ListItem sx={{ px: 0 }}>
                                            {/* <ListItemIcon sx={{ minWidth: 36 }}>
                                                <Schedule color="primary" fontSize="small" />
                                            </ListItemIcon> */}
                                            <ListItemText
                                                primary={
                                                    <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600 }}>
                                                        Schedule
                                                    </Typography>
                                                }
                                                secondary={
                                                    <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                                        {notificationData?.scheduleType === 'now' ? 'Send immediately' :
                                                            notificationData?.scheduledDateTime ?
                                                                dayjs(notificationData?.scheduledDateTime).format('MMM DD, hh:mm A') :
                                                                'Not scheduled'
                                                        }
                                                    </Typography>
                                                }
                                            />
                                        </ListItem>

                                        {/* Delivery Modes */}
                                        <ListItem sx={{ px: 0, alignItems: 'flex-start' }}>
                                            {/* <ListItemIcon sx={{ minWidth: 36 }}>
                                                <NotificationsActive color="primary" fontSize="small" />
                                            </ListItemIcon> */}
                                            <ListItemText
                                                primary={
                                                    <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600 }}>
                                                        Delivery Channels
                                                    </Typography>
                                                }
                                                secondary={
                                                    <Box sx={{ mt: 0.5 }}>
                                                        {notificationData?.deliveryModes.map((mode, index) => (
                                                            <Chip
                                                                key={mode}
                                                                icon={getDeliveryModeIcon(mode)}
                                                                label={getDeliveryModeLabel(mode)}
                                                                size="small"
                                                                sx={{
                                                                    fontSize: '0.65rem',
                                                                    height: 20,
                                                                    mr: 0.5,
                                                                    mb: 0.5,
                                                                    bgcolor: 'primary.100',
                                                                    color: 'primary.800'
                                                                }}
                                                            />
                                                        ))}
                                                    </Box>
                                                }
                                            />
                                        </ListItem>
                                    </List>
                                </CardContent>
                            </Card>
                        </Grid>
                        {/* Message Composition */}
                        <Grid item xs={12}>
                            <Card variant="outlined">
                                <CardContent>
                                    {notificationData?.title && notificationData?.body && (
                                        <Box sx={{}}>
                                            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                                                Notification Content:
                                            </Typography>
                                            <Paper 
                                                sx={{ 
                                                    p: 2, 
                                                    bgcolor: 'grey.50', 
                                                    border: '1px dashed', 
                                                    borderColor: 'grey.300',
                                                    // maxWidth: 300
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'primary.main' }}>
                                                        <NotificationsActive sx={{ fontSize: 14 }} />
                                                    </Avatar>
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography variant="subtitle2" sx={{ 
                                                            fontWeight: 600, 
                                                            fontSize: '0.8rem',
                                                            lineHeight: 1.2,
                                                            mb: 0.5
                                                        }}>
                                                            {notificationData?.title}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ 
                                                            fontSize: '0.7rem',
                                                            color: 'text.secondary',
                                                            lineHeight: 1.3
                                                        }}>
                                                            {notificationData?.body}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Paper>
                                        </Box>
                                    )}
                                </CardContent>
                            </Card>
                            
                        </Grid>
                        <Grid item xs={12}>
                            {/* Selected Recipients Preview */}
                            {selectedAudience?.length > 0 && (
                                <Card variant="outlined">
                                <CardContent>
                                <Box>
                                    <Typography variant="subtitle2" gutterBottom sx={{ 
                                        fontWeight: 600, 
                                        fontSize: '0.8rem',
                                        mb: 1
                                    }}>
                                        Selected {notificationData?.audienceType}s ({selectedAudience?.length}):
                                    </Typography>
                                    <Box sx={{ maxHeight: 150, overflowY: 'auto', px: 1 }}>
                                        {selectedAudience?.slice(0, 5).map((recipient, index) => (
                                            <Chip
                                                key={index}
                                                label={`ID: ${recipient}`}
                                                size="small"
                                                sx={{
                                                    fontSize: '0.6rem',
                                                    height: 18,
                                                    mr: 0.5,
                                                    mb: 0.5,
                                                    bgcolor: 'grey.100'
                                                }}
                                            />
                                        ))}
                                        {selectedAudience?.length > 5 && (
                                            <Typography variant="caption" sx={{ 
                                                fontSize: '0.65rem',
                                                color: 'text.secondary',
                                                fontStyle: 'italic'
                                            }}>
                                                +{selectedAudience?.length - 5} more...
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                                </CardContent>
                                </Card>
                            )}
                        </Grid>
                        {notificationData && notificationData?.filters &&
                        <Grid item xs={12}>
                            <Card variant="outlined" sx={{mb:0}}>
                                <CardContent sx={{p:1,mb:0}}>
                                    <Box sx={{display:'flex',gap:1}}>
                                        <Typography variant="subtitle2" gutterBottom sx={{ 
                                            fontWeight: 600, 
                                            fontSize: '0.8rem',
                                            // mb: 1
                                        }}>
                                            Applied Filters
                                            
                                        </Typography>
                                        <AllAppliedFIlters
                                                // filterableColumns={()=>{}}
                                                
                                                // enableGeoFilters={notificationData.audienceType === 'customer' ? true : false}
                                                enableGeoFilters={false}
                                                enableLocationFilters={true}
                                                defaultFilterOptions= {notificationData?.filters.filterOptions}
                                                audienceType= {notificationData?.audienceType === 'customer' ? 'customer' : 'expert'}
                                                // defaultLocationFilters= {notificationData.filters.locationFilters}
                                                notificationData={notificationData}
                                            />
                                    </Box>                                    
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                    </Grid>
                </Grid>
                <Grid item xs={12} md={8}>
                    <MessageList id={id}/>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ViewNotification;